"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var styled_1 = __importDefault(require("../../styled"));
var sidebar_link_1 = __importDefault(require("./sidebar-link"));
var SidebarLinkGroup = (function (_super) {
    __extends(SidebarLinkGroup, _super);
    function SidebarLinkGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            _this.setState({ open: !_this.state.open });
        };
        var subItemSelected = _this.evaluateSubItemSelection(props);
        _this.state = { open: props.defaultOpen || false, subItemSelected: subItemSelected };
        return _this;
    }
    SidebarLinkGroup.prototype.evaluateSubItemSelection = function (props) {
        var subItemSelected = false;
        React.Children.forEach(props.children, function (child) {
            if (child && child.props && child.props.selected) {
                subItemSelected = true;
            }
        });
        return subItemSelected;
    };
    SidebarLinkGroup.prototype.componentDidUpdate = function () {
        var selected = this.evaluateSubItemSelection(this.props);
        if (this.state.subItemSelected !== selected) {
            this.setState({ subItemSelected: selected });
        }
    };
    SidebarLinkGroup.prototype.render = function () {
        var _a = this.props, icon = _a.icon, label = _a.label, children = _a.children;
        var _b = this.state, open = _b.open, subItemSelected = _b.subItemSelected;
        return (React.createElement(SidebarLinkGroup.Element, __assign({}, automation_attribute_1.default('sidebar.group'), this.props),
            React.createElement(sidebar_link_1.default, { icon: icon, label: label, onClick: this.handleClick, selected: subItemSelected }),
            React.createElement(SidebarLinkGroup.Content, { open: subItemSelected || open }, children)));
    };
    SidebarLinkGroup.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
    SidebarLinkGroup.Content = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-left: 1.75em;\n    overflow: hidden;\n    max-height: ", ";\n    visibility: ", ";\n    transition: max-height 0.5s ease, visibility 0.5s ease;\n  "], ["\n    padding-left: 1.75em;\n    overflow: hidden;\n    max-height: ", ";\n    visibility: ", ";\n    transition: max-height 0.5s ease, visibility 0.5s ease;\n  "])), function (props) { return (props.open ? props.children.length * 50 + 'px' : '0'); }, function (props) { return (props.open ? 'visible' : 'hidden'); });
    SidebarLinkGroup.defaultProps = {};
    return SidebarLinkGroup;
}(React.Component));
exports.default = SidebarLinkGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=sidebar-link-group.js.map